import type { Theme } from '@mui/material/styles';

export function remToPx(theme: Theme, rem: string): number {
  return parseFloat(rem) * theme.typography.htmlFontSize;
}
